import { stripHtml } from 'src/utils/html';

export const CONFIGURACAO_LEITURA_FIELDS = {
  ENVIO_AUTOMATICO: 'enviarPendenciaLeituraAutomaticamente',
  PRAZO_DIAS_UTEIS: 'prazoConfirmacaoLeituraDiasUteis',
  TITULO_EMAIL: 'tituloEmailConfirmacaoLeitura',
  CONTEUDO_EMAIL: 'conteudoEmailConfirmacaoLeitura',
};

export const PRAZO_LEITURA_PADRAO = 15;

export const LEITURA_EDITOR_MODULES = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ color: [] }, { background: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link', 'clean'],
  ],
};

export function validarConfiguracaoLeitura(model) {
  const fields = CONFIGURACAO_LEITURA_FIELDS;
  if (model?.agrupador || !model?.[fields.ENVIO_AUTOMATICO]) return [];

  const errors = [];
  const prazo = Number(model[fields.PRAZO_DIAS_UTEIS] ?? PRAZO_LEITURA_PADRAO);
  if (!Number.isSafeInteger(prazo) || prazo < 1)
    errors.push(fields.PRAZO_DIAS_UTEIS);
  if (!model[fields.TITULO_EMAIL]?.trim()) errors.push(fields.TITULO_EMAIL);
  if (!stripHtml(model[fields.CONTEUDO_EMAIL] || '').trim())
    errors.push(fields.CONTEUDO_EMAIL);
  return errors;
}
